import { useState, useEffect } from 'react';

const CONSENT_KEY = 'boostio_cookie_consent';

function saveConsent(analytics: boolean, marketing: boolean) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({
    necessary: true,
    analytics,
    marketing,
    timestamp: new Date().toISOString(),
  }));
}

export default function CookieBanner() {
  const [view, setView] = useState<'hidden' | 'banner' | 'panel'>(() =>
    localStorage.getItem(CONSENT_KEY) ? 'hidden' : 'banner'
  );
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const handler = () => {
      localStorage.removeItem(CONSENT_KEY);
      setView('banner');
    };
    window.addEventListener('boostio:cookie-settings', handler);
    return () => window.removeEventListener('boostio:cookie-settings', handler);
  }, []);

  if (view === 'hidden') return null;

  function acceptAll() {
    saveConsent(true, true);
    setView('hidden');
  }

  function acceptNecessary() {
    saveConsent(false, false);
    setView('hidden');
  }

  function saveCustom() {
    saveConsent(analytics, marketing);
    setView('hidden');
  }

  if (view === 'panel') {
    return (
      <div className="cookie-card cookie-card--wide" role="dialog" aria-modal="true" aria-label="Nastavenia cookies">
        <h3 className="cookie-title">Nastavenia cookies</h3>

        <div className="cookie-toggle-list">
          <div className="cookie-toggle-row">
            <div className="cookie-toggle-info">
              <span className="cookie-toggle-name">Nevyhnutné cookies</span>
              <span className="cookie-toggle-desc">Potrebné pre fungovanie webu. Vždy aktívne.</span>
            </div>
            <div className="cookie-toggle cookie-toggle--disabled" aria-label="Vždy zapnuté">
              <div className="cookie-toggle-thumb" />
            </div>
          </div>

          <div className="cookie-toggle-row">
            <div className="cookie-toggle-info">
              <span className="cookie-toggle-name">Analytické cookies</span>
              <span className="cookie-toggle-desc">Google Analytics – pomáhajú nám zlepšovať web.</span>
            </div>
            <button
              role="switch"
              aria-checked={analytics}
              className={`cookie-toggle${analytics ? ' cookie-toggle--on' : ''}`}
              onClick={() => setAnalytics(v => !v)}
            >
              <div className="cookie-toggle-thumb" />
            </button>
          </div>

          <div className="cookie-toggle-row">
            <div className="cookie-toggle-info">
              <span className="cookie-toggle-name">Marketingové cookies</span>
              <span className="cookie-toggle-desc">Retargeting a personalizovaná reklama.</span>
            </div>
            <button
              role="switch"
              aria-checked={marketing}
              className={`cookie-toggle${marketing ? ' cookie-toggle--on' : ''}`}
              onClick={() => setMarketing(v => !v)}
            >
              <div className="cookie-toggle-thumb" />
            </button>
          </div>
        </div>

        <div className="cookie-panel-actions">
          <button className="btn-primary cookie-save-btn" onClick={saveCustom}>
            Uložiť nastavenia
          </button>
          <button className="cookie-text-link" onClick={acceptAll}>
            Prijať všetky
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cookie-card" role="dialog" aria-modal="true" aria-label="Cookie súhlas">
      <h3 className="cookie-title">🍪 Táto stránka používa cookies</h3>
      <p className="cookie-body">
        Používame nevyhnutné cookies pre fungovanie webu a analytické cookies (Google Analytics)
        pre zlepšenie vášho zážitku. Podľa GDPR máte právo vybrať si.
      </p>
      <div className="cookie-actions">
        <button className="btn-primary cookie-accept-btn" onClick={acceptAll}>
          Prijať všetky
        </button>
        <button className="btn-ghost cookie-minimal-btn" onClick={acceptNecessary}>
          Len nevyhnutné
        </button>
        <button className="cookie-text-link" onClick={() => setView('panel')}>
          Prispôsobiť ▸
        </button>
      </div>
    </div>
  );
}
